import axios from "axios";

// Create an Axios instance
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});
console.log(process.env.REACT_APP_BASE_URL);

// Add a request interceptor to include the token
apiClient.interceptors.request.use((config) => {
  const token = getTokenFromCookies();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Helper to retrieve token from cookies
function getTokenFromCookies() {
  const cookies = document.cookie.split(";");
  const tokenCookie = cookies.find((cookie) =>
    cookie.trim().startsWith("authToken=")
  );
  if (tokenCookie) {
    return tokenCookie.split("=")[1];
  }
  return null;
}

export const authPut = async (arg) => {
  try {
    const response = await apiClient.put(
      `${process.env.REACT_APP_BASE_URL}/${arg.subLink}/${arg.id}`,
      arg.data
    );
    return response.data; // Axios automatically parses the JSON response
  } catch (e) {
    return e;
  }
};
